export default {
	pages: {
		dashboard: '',
		sets: '',
		categories: '',
		news: '',
		filters: '',
		keywords: '',
		products: '',
		orders: '',
		albums: '',
		sliders: '',
		users: '',
		subscriptions: '',
		'about-us': '',
		seo: '',
	}
}